import React from "react";
import {
  ButtonCancel,
  ButtonCreate,
  ContentButtons,
  ContentFields,
  GeneralStyle,
  SelectStyles,
} from "./UpdateEmailTemplate.styled";
import PersonIcon from "@material-ui/icons/Person";
import { Col, Form, Row } from "react-bootstrap";
import EditorConvertToMarkdown from "../EditorConvertToMarkdown/EditorConvertToMarkdown";
import Select1 from "react-select";
import { theme as themeConfig } from "../../themes/themes";

const UpdateEmailTemplate = ({
  name,
  goToBackPage,
  validateData,
  body,
  setBody,
  rDescription,
  rSubject,
  allCountries,
  countrySelected,
  handleChangeSelectCountries,
}) => {
  return (
    <GeneralStyle>
      <div
        style={{
          color: "rgb(123, 123, 123)",
          fontWeight: "700",
          fontSize: "18px",
          display: "flex",
          padding: "0 30px",
          paddingTop: "30px",
        }}
      >
        <PersonIcon style={{ color: themeConfig.neutral.gray[2600] }} />
        Edit Template: {name}
      </div>
      <hr />
      <ContentFields>
        <Row className="w-100">
          <Col md={4} className={"my-3"}>
            <Form.Label>Country</Form.Label>{" "}
            <Select1
              placeholder="Select a country"
              options={allCountries}
              styles={SelectStyles}
              onChange={handleChangeSelectCountries}
              value={countrySelected}
            />
          </Col>
          <Col md={12} className={"my-3"}>
            <Form.Label>Description</Form.Label>{" "}
            <Form.Control
              type="text"
              ref={rDescription}
              placeholder="Type description here"
              onChange={() => {}}
            />
          </Col>
          <Col md={8} className={"my-3"}>
            <Form.Label>
              Subject
              <span style={{ color: "red" }}> *</span>
            </Form.Label>{" "}
            <Form.Control
              type="text"
              ref={rSubject}
              placeholder="Type subject here"
              onChange={() => {}}
            />
          </Col>
          <Col md={8} className={"my-3"}>
            <Form.Label>
              Body
              <span style={{ color: "red" }}> *</span>
            </Form.Label>{" "}
            <EditorConvertToMarkdown
              editor={body}
              setEditor={setBody}
              style={{ width: "100%" }}
            />
          </Col>
        </Row>
      </ContentFields>
      <hr />
      <ContentButtons>
        <ButtonCancel onClick={() => goToBackPage()}>Cancel</ButtonCancel>
        <ButtonCreate
          onClick={() => {
            validateData();
          }}
        >
          Update Template
        </ButtonCreate>
      </ContentButtons>
    </GeneralStyle>
  );
};

export default UpdateEmailTemplate;
